import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import Backdrop from "@mui/material/Backdrop";

import { Loader, LoaderWrapper } from "../styled";

const BackdropWithSpinner: FC = () => {
    const { t } = useTranslation();
    return (
        <Backdrop open>
            <LoaderWrapper>
                <Loader />
                <span className="sr-only">{t("Common.Loading")}</span>
            </LoaderWrapper>
        </Backdrop>
    );
};

export default BackdropWithSpinner;
